export { useRewardsPromoHeading } from './useRewardsPromoHeading';
